import React, { useEffect, useState } from 'react';
import '../styles/Myprofile.css';
import { EditOutlined, EyeInvisibleOutlined, EyeTwoTone, LeftOutlined, PictureFilled, RightOutlined } from '@ant-design/icons';
import { Input, Select, Button, Modal, message, Upload, Form } from 'antd';
import { Link } from 'react-router-dom';
import profile from "../assets/profile.png";
import user from "../assets/user.png";
import mail from "../assets/mail.png";
import { AppleFilled, GoogleOutlined } from '@ant-design/icons';
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { useDispatch, useSelector } from 'react-redux';
import { fetchUser } from '../redux/getUserSlice';
import { updateProfileFunction } from '../redux/profileUpdateSlice';
import { useTranslation } from 'react-i18next';
import { updateImageProfile } from '../redux/updateImageProfileSlice';

const MyProfile = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    // const [isModalOpenTwo, setIsModalOpenTwo] = useState(false);
    const [isModalOpenAdd, setIsModalOpenAdd] = useState(false);
    const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);
    const [selected, setSelected] = useState("provider");

    const { t, i18n } = useTranslation();

    const { language } = i18n;

    const [name, setName] = useState("");
    const [lastname, setLastname] = useState("");
    const [email, setEmail] = useState("");
    // const [address, setAddress] = useState("");
    const [phone, setPhone] = useState("");

    const dispatch = useDispatch();

    const { getUser, status, error } = useSelector((state) => state.getUser);

    useEffect(() => {
        dispatch(fetchUser());
    }, [dispatch]);

    useEffect(() => {
        if (getUser?.name) {
            setName(getUser.name);
        }
        if (getUser?.last_name) {
            setLastname(getUser.last_name);
        }
        if (getUser?.email) {
            setEmail(getUser.email);
        }
        if (getUser?.phone) {
            setPhone(getUser.phone);
        }
        // if (getUser?.address) {
        //     setAddress(getUser.address);
        // }
    }, [getUser]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name || !lastname || !email || !phone) {
            message.error(t("All fields are required"));
            return;
        }

        const profileData = { name, lastname, email, phone };

        try {
            const updateProfile = await dispatch(updateProfileFunction(profileData)).unwrap();
            message.success(t("Profile updated successfully"));
        } catch (error) {
            console.error("Error:", error);
            message.error(t("Something went wrong. Please try again."));
        }
    };

    const [fileList, setFileList] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);
    const [isEditing, setIsEditing] = useState(false);

    // const handleUploadChange = ({ fileList: newFileList }) => {
    //     setFileList(newFileList);
    // };

    const handleUploadChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);
        if (newFileList.length > 0) {
            const newImage = newFileList[0].originFileObj;
            setPreviewImage(URL.createObjectURL(newImage));
            setIsEditing(true);
        }
    };


    // const handleImageUpdate = () => {
    //     if (fileList.length === 0) {
    //         message.error(t("Please upload one image!"));
    //         return;
    //     }

    //     const formData = new FormData();
    //     formData.append("image", fileList[0].originFileObj);

    //     dispatch(updateImageProfile(formData));
    // };

    const handleImageUpdate = () => {
        if (fileList.length === 0) {
            message.error(t("Please upload one image!"));
            return;
        }

        const formData = new FormData();
        formData.append("image", fileList[0].originFileObj);

        dispatch(updateImageProfile(formData)).then(() => {
            setIsEditing(false);
            message.success(t("Profile picture updated successfully!"));
        });
    };


    const handleChange = (value) => {
        console.log(`selected ${value}`);
    };

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    // const showModalTwo = () => {
    //     setIsModalOpenTwo(true);
    // };
    // const handleOkTwo = () => {
    //     setIsModalOpenTwo(false);
    // };
    // const handleCancelTwo = () => {
    //     setIsModalOpenTwo(false);
    // };

    const showModalAdd = () => {
        setIsModalOpenAdd(true);
    };

    const handleCancelAdd = () => {
        setIsModalOpenAdd(false);
    };

    const showModalEdit = () => {
        setIsModalOpenEdit(true);
    };

    const handleCancelEdit = () => {
        setIsModalOpenEdit(false);
    };
    return (
        <div className='Myprofile'>
            <div className='bg-[#FCFBFA]'>
                <div className='px-20 max-lg:px-5'>
                    <Link to='/' className='flex items-center text-[#283D63] text-lg py-10 max-lg:py-5 font-semibold'>
                        {
                            language == "en" ? <>
                                <LeftOutlined />
                                <p className='ml-2'>{t("Back to home")}</p>
                            </> : <>
                                <RightOutlined />
                                <p className='mr-2'>{t("Back to home")}</p>
                            </>
                        }
                    </Link>
                    <div className='pb-10'>
                        <h3 className='text-[#14294F] text-2xl font-semibold'>{t("My Profile")}</h3>
                    </div>
                </div>
            </div>
            <div className='px-20 max-lg:px-5 mt-10 pb-10'>
                <div className='grid grid-cols-2 max-lg:grid-cols-1 gap-6'>
                    <div>
                        <div className="flex items-center my-4">
                            <div>
                                {/* {getUser?.image === null ?
                                    <img src={profile} className="w-[80px]" /> :
                                    <img src={`https://samoolah.com/${getUser?.image}`} className="w-[80px]" />
                                } */}
                                <img
                                    src={
                                        previewImage
                                            ? previewImage
                                            : getUser?.image
                                                ? `https://service.samoolah.com/${getUser?.image}`
                                                : profile
                                    }
                                    alt="Profile"
                                    className="w-[80px] rounded-full"
                                    onError={(e) => (e.target.src = profile)}
                                />
                            </div>
                            <div className={language == "en" ? "ml-4": "mr-4"}>
                                <p className='text-[#737E91]'>{t("Hello")},</p>
                                <p className="text-[#14294F] text-xl font-semibold">{getUser?.name} {getUser?.last_name}</p>
                            </div>
                        </div>


                        {isEditing ? (
                            <Button type="primary" onClick={handleImageUpdate}>
                                {t("Confirm")}
                            </Button>
                        ) :
                            <Form.Item
                                name="upload"
                                rules={[
                                    {
                                        required: true,
                                        message: t("Please upload one image!"),
                                    },
                                ]}

                            >
                                <Upload
                                    fileList={fileList}
                                    onChange={handleUploadChange}
                                    beforeUpload={() => false}
                                    listType="picture"
                                    className='cursor-pointer'
                                    showUploadList={false}
                                >
                                    <div className='bg-[#FE9B71] text-white rounded-full flex items-center px-4 py-2 mt-3'>
                                        <PictureFilled />
                                        <p className={`${language == "en" ? "ml-3" : "mr-3"} font-medium`}>{t("Edit profile picture")}</p>
                                    </div>

                                </Upload>
                            </Form.Item>
                        }


                        {/* <Button type="primary" onClick={showModal} className='bg-[#FCFBFA] text-[#525D71] px-6 py-5 w-[400px] max-lg:w-full h-[70px] rounded-xl font-semibold text-lg flex items-center justify-between mt-10 shadow-none' style={{ background: "#FCFBFA", color: "#525D71" }}>
                            <p>Saved addresses</p>
                            <RightOutlined className='text-[#EAA182]' />
                        </Button>
                        <Modal title="Saved Addresses" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null} className='custome_modal'>
                            <div className='grid grid-cols-2 max-lg:grid-cols-1 gap-6 mt-10 mb-5'>
                                <div className='bg-[#FCFBFA] text-[#525D71] px-6 py-4 rounded-xl font-semibold flex items-center justify-between'>
                                    <p>{getUser?.address} Any</p>
                                    <button onClick={showModalEdit}><EditOutlined className='text-[#FE9B71]' /></button>
                                </div>
                            </div>
                            <Button type="primary" onClick={showModalAdd} className='bg-[#FE9B71] text-white px-6 py-5 rounded-full font-semibold flex items-center justify-center mx-auto mt-8 shadow-none' style={{ background: "#FE9B71" }}>
                                Add new address
                            </Button>

                            <Modal title="Add new address" open={isModalOpenAdd} onCancel={handleCancelAdd} footer={null} className='custome_modal custome_modal_addres'>
                                <form className='px-5'>
                                    <div className="mt-5">
                                        <p className="text-[#283D63] font-semibold">
                                            Address Title <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Input
                                            placeholder="Eg. Home address"
                                            className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                        />
                                    </div>
                                    <div className="mt-5">
                                        <p className="text-[#283D63] font-semibold">
                                            Country <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Select
                                            defaultValue="one"
                                            className="w-full mt-2"
                                            onChange={handleChange}
                                            options={[
                                                {
                                                    value: "two",
                                                    label: "Choose one or more services",
                                                },
                                                {
                                                    value: "one",
                                                    label: "Choose country",
                                                },
                                            ]}
                                        />
                                    </div>
                                    <div className="mt-5">
                                        <p className="text-[#283D63] font-semibold">
                                            City <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Select
                                            defaultValue="one"
                                            className="w-full mt-2"
                                            onChange={handleChange}
                                            options={[
                                                {
                                                    value: "two",
                                                    label: "Choose one or more services",
                                                },
                                                {
                                                    value: "one",
                                                    label: "Choose city",
                                                },
                                            ]}
                                        />
                                    </div>
                                    <div className="mt-5">
                                        <p className="text-[#283D63] font-semibold">
                                            Address <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Input
                                            placeholder="Eg. place / Street / Building name / Apartment"
                                            className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                        />
                                    </div>
                                    <button type="primary" className='bg-[#FE9B71] text-white px-14 py-2 rounded-3xl font-semibold flex items-center justify-center mx-auto mt-8 shadow-none' style={{ background: "#FE9B71" }}>
                                        ADD
                                    </button>
                                </form>
                            </Modal>

                            <Modal title="Edit address" open={isModalOpenEdit} onCancel={handleCancelEdit} footer={null} className='custome_modal custome_modal_addres'>
                                <form className='px-5'>
                                    <div className="mt-5">
                                        <p className="text-[#283D63] font-semibold">
                                            Address Title <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Input
                                            placeholder="Eg. Home address"
                                            className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                        />
                                    </div>
                                    <div className="mt-5">
                                        <p className="text-[#283D63] font-semibold">
                                            Country <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Select
                                            defaultValue="one"
                                            className="w-full mt-2"
                                            onChange={handleChange}
                                            options={[
                                                {
                                                    value: "two",
                                                    label: "Choose one or more services",
                                                },
                                                {
                                                    value: "one",
                                                    label: "Choose country",
                                                },
                                            ]}
                                        />
                                    </div>
                                    <div className="mt-5">
                                        <p className="text-[#283D63] font-semibold">
                                            City <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Select
                                            defaultValue="one"
                                            className="w-full mt-2"
                                            onChange={handleChange}
                                            options={[
                                                {
                                                    value: "two",
                                                    label: "Choose one or more services",
                                                },
                                                {
                                                    value: "one",
                                                    label: "Choose city",
                                                },
                                            ]}
                                        />
                                    </div>
                                    <div className="mt-5">
                                        <p className="text-[#283D63] font-semibold">
                                            Address <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Input
                                            placeholder="Eg. place / Street / Building name / Apartment"
                                            className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                        />
                                    </div>
                                    <button type="primary" className='bg-[#FE9B71] text-white px-14 py-2 rounded-3xl font-semibold flex items-center justify-center mx-auto mt-8 shadow-none' style={{ background: "#FE9B71" }}>
                                        EDIT
                                    </button>
                                </form>
                            </Modal>

                        </Modal> */}

                        {/* <Button type="primary" onClick={showModalTwo} className='bg-[#FCFBFA] text-[#525D71] px-6 py-5 w-[400px] max-lg:w-full h-[70px] rounded-xl font-semibold text-lg flex items-center justify-between mt-5 shadow-none' style={{ background: "#FCFBFA", color: "#525D71" }}>
                            <p>Change Password</p>
                            <RightOutlined className='text-[#EAA182]' />
                        </Button>
                        <Modal title="Change Password" open={isModalOpenTwo} onOk={handleOkTwo} onCancel={handleCancelTwo} footer={null} className='custome_modal'>
                            <form className='w-2/3 mx-auto'>
                                <div className='mt-5'>
                                    <p className="text-[#283D63] text-center text-lg font-medium">
                                        Password <span className="text-[#CC0F0F]">*</span>
                                    </p>
                                    <Input.Password
                                        placeholder="Type your password"
                                        iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                        className='h-[50px] mt-2 border-0 bg-[#F9FBFC]'
                                    />
                                </div>
                                <div className='mt-5 mb-2'>
                                    <p className="text-[#283D63] text-center text-lg font-medium">
                                        New Password <span className="text-[#CC0F0F]">*</span>
                                    </p>
                                    <Input.Password
                                        placeholder="Type your password"
                                        iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                        className='h-[50px] mt-2 border-0 bg-[#F9FBFC]'
                                    />
                                </div>
                                <Link to="/forgotPassword" className='text-[#14294F] text-base'>Forgot password?</Link>
                                <button type="primary" className='bg-[#FE9B71] text-white px-14 py-2 rounded-3xl font-semibold flex items-center justify-center mx-auto mt-8 shadow-none'>
                                    Update
                                </button>
                            </form>
                        </Modal> */}

                    </div>
                    <div>
                        <div className='bg-[#FCFBFA] rounded-2xl py-2'>
                            <form onSubmit={handleSubmit} className="my-5 mx-7 max-lg:mx-3">
                                <div className="bg-white border-2 border-[#EAA182] rounded-3xl p-7">
                                    <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10">
                                        <div>
                                            <p className="text-[#283D63] text-center">
                                                {t("First Name")} <span className="text-[#CC0F0F]">*</span>
                                            </p>
                                            <Input
                                                placeholder={t("Eg. Johnny")}
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                suffix={<img src={user} className="w-[15px]" />}
                                                className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                            />
                                        </div>
                                        <div>
                                            <p className="text-[#283D63] text-center">
                                                 {t("Last Name")} <span className="text-[#CC0F0F]">*</span>
                                            </p>
                                            <Input
                                                placeholder={t("Eg. Doe")}
                                                value={lastname}
                                                onChange={(e) => setLastname(e.target.value)}
                                                suffix={<img src={user} className="w-[15px]" />}
                                                className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-5" dir="ltr">
                                        <p className="text-[#283D63] text-center">
                                             {t("Phone Number")} <span className="text-[#CC0F0F]">*</span>
                                        </p>

                                        <PhoneInput
                                            defaultCountry="sa"
                                            value={phone}
                                            onChange={(phone) => setPhone(phone)}
                                            className={`bg-white w-full p-2 rounded placeholder:text-black placeholder:text-xl placeholder:font-normal placeholder:font-Arimo`}
                                        />
                                    </div>

                                    <div className='mt-5'>
                                        <p className="text-[#283D63] text-center">
                                            {t("Email")} <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Input
                                            placeholder="Eg. Solimannhene16@gmail.com"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            suffix={<img src={mail} className="w-[20px]" />}
                                            className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                        />
                                    </div>

                                    {/* <div className='mt-5'>
                                        <p className="text-[#283D63] text-center">
                                            Address <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Input
                                            placeholder="Suez, Egypt"
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                            className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                        />
                                    </div> */}
                                </div>
                                <button type="submit" className="bg-[#FE9B71] text-white rounded-full px-8 py-3 mt-5 flex mx-auto font-semibold text-lg">
                                    {t("Save changes")}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyProfile;
